/*eslint-disable */
import React, { useCallback, useEffect } from 'react';
import { fixedBody, looseBody } from '@/utils/fn';
import { openPageNative } from '@/utils/bridge';
import { reportClick } from '@/utils/report';
import NoData from '../../components/NoData';
import { PAGE_NAME } from '../index';
import styles from '../../styles/welfare.less';

const DeviceModel = ({ onClose, handleBindDevice, deviceList }) => {
  const handleCloseModal = useCallback(() => {
    onClose();
  }, []);

  const handleAddNewDevice = useCallback(() => {
    reportClick({ page_name: PAGE_NAME, button_name: 'add_btn' });
    openPageNative({ url: 'page:qr_scan?origin=0' });
  }, []);

  useEffect(() => {
    fixedBody();
    return looseBody;
  }, []);
  return (
    <div className={styles['modal-mask']} onClick={handleCloseModal}>
      <div className={styles['modal-content']} onClick={e => e.stopPropagation()}>
        <h3 className={styles['modal-title']}>
          选择设备
          <i className={styles['close']} onClick={handleCloseModal} />
        </h3>
        {deviceList?.length > 0 ? (
          <ul className={styles['device-list']}>
            {deviceList.map((device, index) => (
              <li className={styles['device-item']} key={index}>
                <div className={styles['device-text']}>
                  <h4 className={styles['device-sn']}>{device.sn}</h4>
                  <p className={styles['device-info']}>
                    <span className={styles['device-group']}>{device.group || '未知'}</span>
                    <span className={styles['device-type']}>{device.device_name || '--'}</span>
                  </p>
                </div>
                <button className={styles['bind-btn']} onClick={() => handleBindDevice(device)}>
                  使用
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <NoData
            text={
              <p>
                您没有满足条件设备可使用，
                <br />
                快点击下方添加新设备吧！
              </p>
            }
          />
        )}
        <div className={styles['modal-footer']}>
          <button className={styles['add-btn']} onClick={handleAddNewDevice}>
            添加新设备
          </button>
        </div>
      </div>
    </div>
  );
};
export default DeviceModel;
